module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=YT - Mayotte.fa9c7977.svg";